/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchGetBreakSettings} from '../api'

export const useMutationBatchGetBreakSettings = createReactQueryMutationHook('batchGetBreakSettings', batchGetBreakSettings)
